import axios from 'axios';
import React, { Component, useEffect, useMemo } from 'react';
import { Button, Col, Container, Row, } from 'react-bootstrap';
import { Link, Outlet, Navigate, useSearchParams, useParams, useLocation } from "react-router-dom";


function M1() {
  const [isLoad, setIsLoad] = React.useState(true);
  const tryLogin = (login, pass) => {
    var url = "http://46.175.145.158/";
    setIsLoad(true)

    axios.post(url + "mt-api.php", "id=0&login=" + login + "&pass=" + pass + "").then(res => {

      if (res.data.skey) {
        localStorage.setItem("name", res.data.name);
        localStorage.setItem("login", login);
        localStorage.setItem("dbname", res.data.dbname);
        localStorage.setItem("url", res.data.url);
        localStorage.setItem("skey", res.data.skey);
        localStorage.setItem("pass", res.data.pass);
        localStorage.setItem("globalGroup", res.data.globalGroup);
        localStorage.setItem("globalGroupKlient", res.data.globalGroupKlient);
        localStorage.setItem("startsesss", Date.now());
      } else return (<Navigate to={localStorage.getItem("lp") + "Login"} replace={true} />);
      setIsLoad(false)

    }).catch(() => {
      alert("Ошибка связи с сервером");
    })
  };

  const query = useLocation().search;
  let lg = useMemo(() => new URLSearchParams(query).get('l'), [query]);
  let pr = useMemo(() => new URLSearchParams(query).get('p'), [query]);
  let key = useMemo(() => new URLSearchParams(query).get('key'), [query]);

  useEffect(() => {
    if (key == 'CI16bOyv')
      tryLogin(lg, pr)
    else setIsLoad(false)
  }, [key, lg, pr]);

  if (!isLoad)
    return <Main />
  else return null;
}

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: -1,
    };
  }


  render() {
    var skey = localStorage.getItem("skey") || false;
    if (!skey) { return (<Navigate to={localStorage.getItem("lp") + "Login"} replace={true} />); }

    let name = localStorage.getItem("name") || "";
    let dbname = localStorage.getItem("dbname") || "";

    return (

      <div className='titl'>
        <Container>
          <Row className='p-5'>
            <div className='titl-info-block'>
              <table className='w-100'>
                <thead></thead>
                <tbody>
                  <tr>
                    <td className='br-1'>Имя</td>
                    <td>{name}</td>
                  </tr>
                  <tr className='bt-1 bb-1 '>
                    <td className='br-1'>База данных</td>
                    <td>{dbname}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Row>
          <Row >
            <Col className='p-3' xs={6} md={4}>
              <Link title="Создать новый заказ" to={localStorage.getItem("lp") + "Order"}>  <Button className='butn w-100'>Заказ</Button></Link>
            </Col>
            <Col className='p-3' xs={6} md={4}>
              <Link title="Журнал неоплаченных накладных" to={localStorage.getItem("lp") + "help"}><Button className='butn w-100'>Помощь</Button></Link>
            </Col>
            <Col className='p-3' xs={6} md={4}>
              <Button className='butn w-100' onClick={() => { localStorage.removeItem('skey'); this.setState({ status: 0 }) }}>Выход</Button>
            </Col>
            <div><Outlet /></div>
          </Row>
        </Container>

      </div>
    );

  }
}


export default M1;